import { DEFAULT_MAX_FILES } from '@documents/constants'
import { getDropzoneConfigForDocumentType } from '@documents/contexts/file-upload-context/utils'
import { DocumentTypeOption } from '@documents/types'

export function getCanUploadMoreFiles({
  currentFileCount,
  documentType,
}: {
  currentFileCount: number
  documentType: DocumentTypeOption | null
}) {
  const dropzoneConfig = getDropzoneConfigForDocumentType(documentType)

  return currentFileCount < (dropzoneConfig?.maxFiles ?? DEFAULT_MAX_FILES)
}
